import images from "../afbeeldingen/images";

const ProjectPromotiefilmpje = {
  title: "Promotiefilmpje autohandelaar",
  subtitle: "context",
  year: "Eigen project",
  description:
    "Voor een privéproject heb ik een promotiefilmpje gemaakt voor een autohandelaar. Hij vroeg mij om een filmpje te maken dat niet te lang was, maar dat nog steeds veel vertelde. Dit filmpje heb ik gemaakt met DaVinci Resolve. Davinci Resolve is een gratis editprogramma waar je video's in kan toevoegen om zo de video's aan elkaar te kunnen knippen en vervolgens wat tekst bij toe te voegen. Het filmpje kunt u bekijken als u het project opent.",
  video: "/promotiefilmpje_centercars_(2).mp4",
  extraContentHTML: `
        <h4>Besluit</h4>
        <p>
          Ik heb geleerd om te werken met <b>DaVinci Resolve</b>. Ik had nog nooit gewerkt met DaVinci Resolve, dus ik heb dit geleerd door filmpjes te bekijken op YouTube en <b>zelf dingen uit te testen</b>. Ook heb ik geleerd om met een <b>klant te communiceren</b>. Ik heb hem moeten vragen wat hij precies wilde hebben en of het filmpje goed was natuurlijk.
        </p>
      `,
  extraContentJSX: (
    <div className="mt-4">
      <video controls style={{ width: "100%" }}>
        <source src="../promotiefilmpje_centercars_(2).mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  ),
  image: images.promotiefilmpje,
};
export default ProjectPromotiefilmpje;
